import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterSideOf extends Bloc {

	constructor (src, ctx) {

		super("filtersideof", src, ctx);
		this.f = (src, ins) => [card => card.master.hand.cards.indexOf(card) >= 0 && card.master.hand.cards.indexOf(ins[0]) >= 0 && (ins[1] ? card.master.hand.cards.indexOf(card) < card.master.hand.cards.indexOf(ins[0]) : card.master.hand.cards.indexOf(ins[0]) < card.master.hand.cards.indexOf(card))];
		this.types = [Types.cards, Types.bool];
	}
}